<template>
  <v-card class="mx-auto">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="primary text-h5 text-left white--text"
          ><span>
            Comments
            <BaseTooltipButton
              v-if="userHasEditPerms"
              @click.stop="$refs.commentForm.addComment()"
              icon="mdi-plus"
              class="float-right"
              iconColor="secondary"
              buttonClass="white"
              x-small
              >Add Comment
            </BaseTooltipButton>
          </span>
          <template v-slot:actions>
            <v-icon class="white--text">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <div class="viewer" id="note-view">
              <template>
                <div v-for="c in sortedComments" :key="c.ID">
                  <div class="comment" :class="getNoteClass(c)"
                    ><TuiViewer v-model="c.Note"></TuiViewer>
                    <div
                      class="user-data"
                      :class="
                        c.CreatedByID == currentUser.ID ? 'user-comment' : ''
                      "
                      ><span
                        v-if="c.CreatedBy.FirstName && c.CreatedBy.LastName"
                        >{{ c.CreatedBy.FirstName }}
                        {{ c.CreatedBy.LastName }}</span
                      ><span v-else>
                        {{ c.CreatedBy.Email }}
                      </span>
                      -
                      {{ c.CreatedDate | formatDateTime }}
                      <span v-if="c.CreatedByID == currentUser.ID">
                        <BaseTooltipButton
                          x-small
                          @click="$refs.commentForm.editComment(c)"
                          iconColor="primary"
                          icon="mdi-pencil"
                          >Edit Comment
                        </BaseTooltipButton>
                        <BaseTooltipButton
                          x-small
                          @click="$refs.commentDelete.deleteConfirm(c)"
                          iconColor="primary"
                          icon="mdi-delete"
                          >Delete Comment
                        </BaseTooltipButton>
                      </span>
                      <template v-if="c.IsPrivate">
                        <v-icon small>visibility_off</v-icon>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <v-row>
            <v-col class="ml-auto" cols="12" sm="auto">
              <v-text-field
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="mt-4 mr-4"> </v-col>
          </v-row> -->
      <!-- <v-data-table
          :headers="filteredHeaders"
          :items="comments"
          :search="searchText"
          class="pt-4"
          :loading="loading"
          dense
        >
          <template v-slot:item.edit="{ item }">
          </template>
          <template v-slot:item.delete="{ item }">
          </template>
        </v-data-table> -->
      <BaseDeleteConfirm
        ref="commentDelete"
        :delete="deleteComment"
        @refresh="$emit('refresh')"
      >
        Are you sure you want to delete this comment?
      </BaseDeleteConfirm>
      <CommentDialogForm ref="commentForm" @refresh="$emit('refresh')">
      </CommentDialogForm>
    </v-expansion-panels>
  </v-card>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import CommentDialogForm from '@components/form/add-edit/CommentDialog'
import TuiViewer from '@components/TuiViewer'
import { authMethods, authComputed } from '@state/helpers'
export default {
  components: {
    CommentDialogForm,
    TuiViewer,
  },

  props: {
    comments: {
      type: Array,
      required: true,
    },
    loading: Boolean,
  },
  data: () => ({
    searchText: '',
    panel: [0],
  }),
  created() {},
  computed: {
    ...authComputed,
    ...get('trackedBill', ['selectedTrackedBill']),
    sortedComments() {
      return this.comments
        .filter((c) => true)
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
    },
    userHasEditPerms() {
      return (
        this.selectedTrackedBill.currentUserPermissionID == 1 ||
        this.selectedTrackedBill.currentUserPermissionID == 2 ||
        this.selectedTrackedBill.currentUserPermissionID == 5
      )
    },
  },
  methods: {
    ...call('comment', ['deleteComment']),
    getNoteClass(c) {
      var classes = ''
      classes += c.IsPrivate ? ' private-comment' : ''
      classes +=
        c.CreatedByID == this.currentUser.ID
          ? ' user-comment'
          : ' non-user-comment'
      return classes
    },
  },
}
</script>
<style scoped>
.comment {
  /* white-space: pre-wrap; */
  margin: 5px;
  min-height: 50px;
  min-width: 200px;
  max-width: 85%;
  border-radius: 5px;
  padding: 4px;
  /* color: black; */
  background-color: #dcebf3;
}
.user-comment {
  /* text-align: right; */
  margin-right: 0px;
  margin-left: auto;
}
.private-comment {
  background-color: #e3e6e7 !important;
}
</style>
